/** @jsxImportSource @emotion/react */
import React from 'react'
import * as styles from './index.styles'

export type Props = {
  style?: any
  action?: React.ReactNode
}

const HeaderSection: React.FC<Props> = ({ children, action, style }) => (
  <div css={(theme: any) => styles.root({ theme, style })}>
    <div>{children}</div>
    {action && <div>{action}</div>}
  </div>
)

export default HeaderSection
